import React from "react";

const IconTelegramWhite = () => {
    return (
        <svg
            width="512"
            height="512"
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#IconTelegramWhite)">
                <path
                    d="M8.8515 238.848L134.057 301.248C138.899 303.638 144.617 303.467 149.246 300.758L260.692 235.968L193.235 295.744C189.801 298.795 187.838 303.147 187.838 307.734V453.334C187.838 468.694 207.444 475.158 216.638 462.955L270.761 390.998L404.606 467.222C413.993 472.619 426.025 467.2 428.201 456.47L511.678 40.4696C514.174 27.9683 501.737 17.7709 490.174 22.4216L10.1742 209.622C-2.71117 214.656 -3.54317 232.683 8.8515 238.848V238.848ZM474.558 62.8696L401.193 428.459L274.366 356.224C267.454 352.278 258.558 354.027 253.652 360.512L219.838 405.462V314.923L402.26 153.302C416.702 140.523 400.105 117.803 383.614 127.488L140.627 268.758L55.4648 226.326L474.558 62.8696Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="IconTelegramWhite">
                    <rect width="512" height="512" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconTelegramWhite;
